if (!customElements.get('signup-modal')) {
  customElements.define('signup-modal', class SignupModal extends ModalDialog {
    constructor() {
      super();

      if (window.designMode.enabled !== 'true') {
        this.delay = parseInt(this.dataset.delay) || 9000;

        if (sessionStorage.getItem('rivr-people-popup-seen') !== 'true') {
          setTimeout(() => {
            this.show();
          }, this.delay);
        }
      } else {
        this.addEventListeners();
      }
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      sessionStorage.setItem('rivr-people-popup-seen', 'true');
    }

    addEventListeners() {
      document.addEventListener('shopify:section:select', (event) => {
        this.hide();

        const id = event.detail.sectionId;
        if (id != 'sign-up-modal') return;

        const opener = `#SignupModal-${id} button`;
        this.show(opener);
      });

      document.addEventListener('shopify:section:deselect', () => {
        this.hide();
      });
    }
  });
}